/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ruian_PlaceholderInputs */

const cs_ruian_placeholder = /** @type {(inputs: Ruian_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Začněte psát adresu…`)
};

const en_ruian_placeholder = /** @type {(inputs: Ruian_PlaceholderInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Start typing an address…`)
};

/**
* | output |
* | --- |
* | "Start typing an address…" |
*
* @param {Ruian_PlaceholderInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const ruian_placeholder = /** @type {((inputs?: Ruian_PlaceholderInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ruian_PlaceholderInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ruian_placeholder(inputs)
	return cs_ruian_placeholder(inputs)
});